
import ContactUs from "../../components/ContactUs";
import PlanCards from "../../components/PlanCardSection";
import SliderViewSection from "../../components/SliderViewSection";
import StayInLoop from "../../components/StayInLoop";
import TestimonialSlider from "../../components/FeedbackSlider";
import { CardSwapImg, 
    One7,
 One2,
 One3,
 One4,
 One5,
 One6, 
 AllProductGif} from "../../constant";
import ProductLanding from "../../components/Products/ProductLanding";
import FourCardsSwap from "../../components/FourCardSwapSection";

const videoTabData = [
  {
    label: "EHS",
    key: "1",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
  {
    label: "EGS",
    key: "2",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
  {
    label: "Carbon",
    key: "3",
    videoUrl:
      "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
  },
];


const safetyAndSustainabilityData = [
  {
    title: "ONE. Business Operations & Compliance, Unified.",
    subtitle:
      "Manage daily operations, workforce coordination, customer engagement and compliance obligations through a single intelligent platform built for modern businesses.",
    lists: [
      "Unified Business Management",
      "Workforce & Operational Visibility",
      "Built-In Compliance Workflows",
    ],
    mediaUrl:  One7,
  },

  {
    title: "Empower Teams. Streamline Execution.",
    subtitle:
      "Improve productivity with connected workflows, task tracking, attendance visibility and real-time operational coordination across teams.",
    lists: [
      "Task & Workflow Management",
      "Team Collaboration Tools",
      "Real-Time Productivity Tracking",
    ],
    mediaUrl: One2,
  },

  {
    title: "Run Daily Business Operations Seamlessly.",
    subtitle:
      "Digitize routine business activities and centralize operational processes to improve efficiency, transparency and decision-making.",
    lists: [
      "Process Automation",
      "Centralized Business Workflows",
      "Operational Performance Insights",
    ],
    mediaUrl: One3,
  },

  {
    title: "Stay Ahead of Labour & Safety Compliance.",
    subtitle:
      "Manage labour law obligations, occupational health & safety requirements and regulatory compliance through structured digital workflows.",
    lists: [
      "Labour Law Management",
      "Occupational Health & Safety Tracking",
      "Regulatory Compliance Monitoring",
    ],
    mediaUrl: One4,
  },

  {
    title: "Turn Operational Data into Actionable Insights.",
    subtitle:
      "Gain visibility into business performance, workforce trends and operational bottlenecks with intelligent analytics and centralized reporting.",
    lists: [
      "Business Performance Analytics",
      "Workforce & Operations Insights",
      "Smart Reporting Dashboards",
    ],
    mediaUrl: One5,
  },

  {
    title: "One Platform. Endless Business Possibilities.",
    subtitle:
      "Whether managing teams, operations, compliance, or communication, ONE adapts to growing business needs with scalable, secure, and connected digital capabilities.",
    lists: [
      "Scalable Cloud Platform",
      "Secure and connected ecosystem",
      "Designed for modern enterprises & startups",
    ],
    mediaUrl: One6,
  },
];



const AuroraSRPPlans = [
  {
    title: "Starter",
    features: [
      "Workforce & Attendance Management",
      "Task and Workflow Tracking",
      "Leave Scheduling",
      "Basic Compliance Monitoring",
    ],
  },

  {
    title: "Growth",
    features: [
      "Everything in Starter",
      "Employee Productivity Monitoring",
      "Marketing Campaigns Management",
      "Payroll Management",
    ],
    popular: true,
  },

  {
    title: "Enterprise",
    features: [
      "Everything in Growth",
      "Occupational Health & Safety Management",
      "Advanced Governance & Audit Tracking",
      "API Integrations & Enterprise Customization",
    ],
    recommended: true,
  },
];


const testimonialsData = [
  {
    quote:
      "NetZero enabled us to streamline ESG reporting and improve sustainability visibility across operations.",
    author: "General Manager, EHS",
    note: "An Integrated Energy Enterprise",
  },
  {
    quote:
      "The platform transformed our EHS processes with real-time monitoring, analytics, and actionable insights.",
    author: "Project Safety Head",
    note: "Major Oil & Gas Operator",
  },
  {
    quote:
      "Aurora helped us connect critical industrial assets and improve operational efficiency significantly.",
    author: "Project Manager",
    note: "An Integrated Oil & Gas Operator",
  },
  {
    quote:
      "We now manage compliance, audits, and sustainability reporting from a single intelligent platform.",
    author: "Head, Digital Transformation",
    note: "A Large Mining Company",
  },
  {
    quote:
      "Implementation was seamless, and the solution scaled perfectly across our enterprise operations.",
    author: "Chief Manager – Projects",
    note: "A Large Refining Company",
  },
  {
    quote:
      "The risk engagement simplified complex reporting requirements while improving data accuracy and governance.",
    author: "Chief Risk Officer",
    note: "A Large Power Generation Company",
  },
  {
    quote:
      "Connected operational intelligence and sustainability insights helped us achieve measurable business outcomes.",
    author: "Head – Projects",
    note: "One of the Largest EPC Players",
  },
  {
    quote:
      "Real-time visibility into risks, emissions, and compliance improved our overall operational performance.",
    author: "Head – Sustainability",
    note: "A Large Defence Manufacturer",
  },
  {
    quote:
      "A modern digital transformation platform that delivers measurable impact across EHS, ESG, and operations.",
    author: "Nodal Officer, Digital Initiatives",
    note: "One of the Largest Mining Operators",
  },
];

const FourCardsSwapcardData = [
  {
    title: "People in Sync",
    description:
      "Simplify team management, attendance, scheduling and performance to keep your workforce aligned and engaged.",
  },

  {
    title: "Workflows That Move Business",
    description:
      "Create, automate and manage business processes seamlessly to improve efficiency and accelerate execution.",
  },

  {
    title: "Governance Made Simple",
    description:
      "Stay ahead of regulatory changes with structured compliance, safety and policy management.",
  },

  {
    title: "Ready for Where You Grow",
    description:
      "Flexible, secure and scalable platform designed to support your business journey today and tomorrow.",
  },
];


export default function ProductOne() {
  return (
    <>
      <ProductLanding
        title={`ONE App for Unified Business & Compliance Management `}
        subTitle={`Simplify business management with ONE—an integrated platform for HR, payroll, productivity, sales, and daily operations, combined with labour, occupational health & safety, and statutory compliance management. Built to help growing businesses operate smarter, stay compliant, and scale confidently.`}
        isNetzero={false}
        url={AllProductGif}
      />
      <SliderViewSection
        title={"Built for Business. Designed for Compliance."}
        subTitle={"ONE connects your teams, workflows, operations, and compliance obligations through a single digital platform. Streamline workforce coordination, operational tracking, communication, and business execution while staying aligned with labour regulations, occupational health & safety standards, and evolving statutory requirements."}
        data={safetyAndSustainabilityData} />
      <FourCardsSwap
        title={"ONE adapts to the way you work."}
        subTitle={"From workforce coordination and operational management to compliance tracking and business visibility, ONE provides connected digital capabilities designed for growing businesses and modern."}
        cardData={FourCardsSwapcardData}
      />


      {/* <CardCrausalView /> */}
      {/* <CardSwapSectionComponent data={safetyAndSustainabilityData} /> */}
      <TestimonialSlider testimonials={testimonialsData} />
      <PlanCards productName = {"One"} title={"ONE Deployment Plans "} plans={AuroraSRPPlans} />
      <ContactUs />
      <StayInLoop />
    </>
  );
}
